// eslint-disable-next-line import/prefer-default-export, no-shadow
  export enum EstimatedValuesActionTypes {
    GET_ESTIMATED_VALUES = 'GET_ESTIMATED_VALUES',
  }
  